import { VipProcessTemplate } from '@app/pages/checkout-app/checkout-layout/main/components/extensions/components/extension-components/vip-process/model';
export class VipProcessDto {
  constructor() {}

  createVIProcessTemplateDTO(template: VipProcessTemplate | any): VipProcessTemplate {
    const templateObj: any = {};
    if (template.title) {
      templateObj.title = template.title;
    }
    if (template.description) {
      templateObj.description = template.description;
    }
    if (template.upsellRate) {
      templateObj.upsellRate = template.upsellRate;
    }
    if (template.discount) {
      templateObj.discount = template.discount;
    }
    if (template.prioritizeOrder != undefined) {
      templateObj.prioritizeOrder = template.prioritizeOrder;
    }

    return templateObj;
  }

  createExampleTemplate() {
    return {
      title: 'Priority processing',
      description: 'Get special service for your order',
      upsellRate: '6',
      discount: '20',
    };
  }
}
